import React, { useState } from 'react';

interface InvitePageProps {
  onBack: () => void;
}

const mockInvitedFriends = [
  { id: 1, name: 'Selin Yıldız', username: '@seliny', date: 'Bugün', reward: 50 },
  { id: 2, name: 'Ahmet Mert', username: '@ahmtt1', date: 'Dün', reward: 50 },
  { id: 3, name: 'GizemliKız', username: '@gizemli', date: '12 Nis', reward: 50 },
];

const InvitePage: React.FC<InvitePageProps> = ({ onBack }) => {
  const [copied, setCopied] = useState(false);
  const inviteCode = 'BUDDY-X9F2';

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{
      width: '100%', height: '100%',
      background: 'linear-gradient(160deg, #12121c, #0e0e18)',
      display: 'flex', flexDirection: 'column',
      position: 'relative', overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '50px 20px 20px',
        background: 'rgba(255,255,255,.02)',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', gap: 15,
        position: 'relative', zIndex: 10
      }}>
        <button onClick={onBack} className="icon-btn" style={{ background: 'rgba(255,255,255,.05)' }}>
          ←
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 24 }}>👥</span>
          <h2 className="syne" style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>Arkadaş Daveti</h2>
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '20px', paddingBottom: '90px' }}>
        
        {/* Banner */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(59,130,246,0.15), rgba(168,85,247,0.15))',
          border: '1px solid rgba(59,130,246,0.3)',
          borderRadius: 24, padding: '24px', textAlign: 'center', marginBottom: 24,
          boxShadow: '0 10px 30px rgba(59,130,246,0.1)', position: 'relative', overflow: 'hidden'
        }}>
          {/* Light flare */}
          <div style={{
            position: 'absolute', top: -40, left: '50%', transform: 'translateX(-50%)',
            width: 150, height: 150, background: 'var(--blue)', filter: 'blur(50px)', opacity: 0.15
          }}></div>
          
          <div style={{ fontSize: 50, marginBottom: 10, position: 'relative' }}>🎁</div>
          <h3 className="syne" style={{ fontSize: 22, fontWeight: 800, color: '#fff', marginBottom: 8, position: 'relative' }}>
            50 Elmas Kazan!
          </h3>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.5, marginBottom: 0, position: 'relative' }}>
            Aşağıdaki kod ile kayıt olan her arkadaşın için anında 50 elmas kazanırsın. Üstelik onlar da VIP Jeton paketi ile başlar.
          </p>
        </div>

        {/* Code Container */}
        <div style={{
          background: 'rgba(255,255,255,.03)', border: '1px solid var(--border)',
          borderRadius: 20, padding: '20px', marginBottom: 30
        }}>
          <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8, fontWeight: 600, textTransform: 'uppercase' }}>
            Senin Davet Kodun
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{
              flex: 1, background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,.05)',
              borderRadius: 14, padding: '14px 16px', display: 'flex', alignItems: 'center',
              fontSize: 20, fontWeight: 800, fontFamily: 'monospace', color: 'var(--cyan)', letterSpacing: 2
            }}>
              {inviteCode}
            </div>
            <button onClick={handleCopy} style={{
              background: copied ? 'var(--green)' : 'var(--blue)', color: '#fff',
              border: 'none', borderRadius: 14, padding: '0 20px',
              fontFamily: 'Syne', fontWeight: 700, fontSize: 14, transition: 'all 0.2s', cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 6, minHeight: '44px'
            }}>
              {copied ? '✓ Kopyalandı' : '📄 Kopyala'}
            </button>
          </div>
        </div>

        {/* Invited List */}
        <div>
          <h3 className="syne" style={{ margin: '0 0 16px 0', fontSize: 17, color: '#fff', display: 'flex', justifyContent: 'space-between' }}>
            <span>Davet Ettiklerin</span>
            <span style={{ color: 'var(--cyan)' }}>Toplam: 150 💎</span>
          </h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {mockInvitedFriends.map(friend => (
              <div key={friend.id} style={{
                background: 'rgba(255,255,255,.02)', border: '1px solid rgba(255,255,255,.05)',
                borderRadius: 16, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12
              }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 14,
                  background: 'linear-gradient(135deg, var(--blue), var(--purple))',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20
                }}>
                  👤
                </div>
                <div style={{ flex: 1 }}>
                  <div className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 2 }}>{friend.name}</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)' }}>{friend.username} • {friend.date}</div>
                </div>
                <div style={{
                  background: 'rgba(0, 229, 204, 0.1)', border: '1px solid rgba(0, 229, 204, 0.2)',
                  borderRadius: 10, padding: '6px 10px', color: 'var(--cyan)', fontWeight: 800, fontSize: 13
                }}>
                  +{friend.reward} 💎
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default InvitePage;
